import { Component, Input, Output, EventEmitter, inject, ChangeDetectionStrategy } from '@angular/core';
import { GenericRosterComponent } from '../generic-roster/generic-roster.component';
import { StudentCardComponent } from './student-card.component';
import { School, SchoolRosterFilter, SchoolTermGradeDto, SchoolGradeYearDto, AttendanceType } from '@k12/models';
import { SchoolsService } from '@k12/school-services';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'lib-graduation-roster',
  template: `
    <lib-generic-roster
      [currentSchool]="currentSchool"
      [editable]="editable"
      [showAdminActions]="showAdminActions"
      [schoolTermId]="schoolTermId"
      [termName]="termName"
      [academicYearId]="academicYearId"
      [reloadTrigger]="reloadTrigger"
      [studentCardComponent]="studentCardComponent"
      [loadStudentsQuery]="loadStudentsQuery"
      [exportQuery]="exportQuery"
      [importQuery]="importQuery"
      [rosterTitle]="rosterTitle"
      [schoolTermGrades]="schoolTermGrades"
      [schoolGradeYears]="schoolGradeYears"
      [attendanceTypes]="attendanceTypes"
      [emptyStateMessage]="emptyStateMessage"
      [searchTerm]="searchTerm"
      (countChanged)="countChanged.emit($event)"
      (saved)="saved.emit($event)"
      (reverted)="reverted.emit($event)">
    </lib-generic-roster>
  `,
  standalone: true,
  // eslint-disable-next-line @angular-eslint/component-class-suffix
  imports: [GenericRosterComponent]
})
export class GraduationRosterComponent {
  @Input() currentSchool: School | null = null;
  @Input() editable = false;
  @Input() showAdminActions = false;
  @Input() schoolTermId: string | null = null;
  @Input() termName: string | null = null;
  @Input() academicYearId: number | null = null;
  @Input() reloadTrigger: number = 0;
  @Input() schoolTermGrades: SchoolTermGradeDto[] = [];
  @Input() schoolGradeYears: SchoolGradeYearDto[] = [];
  @Input() attendanceTypes: AttendanceType[] = [];
  @Input() emptyStateMessage: string = 'No students found for graduation.';
  @Input() searchTerm: string = '';
  @Output() countChanged = new EventEmitter<number>();
  @Output() saved = new EventEmitter<string>();
  @Output() reverted = new EventEmitter<string>();

  get studentCardComponent() {
    return StudentCardComponent;
  }

  private readonly schoolsService: SchoolsService = inject(SchoolsService);
  loadStudentsQuery = (filters: SchoolRosterFilter) => this.schoolsService.getGraduationRosters(filters);
  exportQuery = (mini: boolean, schoolTermId?: string | null) =>
    this.schoolsService.exportGraduationRoster(this.currentSchool!.programPartnerId!, mini, schoolTermId, this.academicYearId);
  importQuery = (file: File, schoolTermId?: string | null) =>
    this.schoolsService.importRoster(this.currentSchool!.programPartnerId!, file, schoolTermId);
  rosterTitle = 'Graduation';
}
